import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservationStateProvider } from '../ReservationContext'
import { getCurrentLanguage } from '../../search-trip/helpers'
import { useCheckoutRecovery } from './useCheckoutRecovery'

const CheckoutRecoveryProvider = ({ bootstrap, children }) => {
    const recovery = useCheckoutRecovery(bootstrap)
    const { i18n } = useTranslation()

    useEffect(() => {
        i18n.changeLanguage(getCurrentLanguage())
    }, [i18n])

    return (
        <ReservationStateProvider value={recovery}>
            {children}
        </ReservationStateProvider>
    )
}

export default CheckoutRecoveryProvider
